define('NVT.anuualupdateform.anuualupdateformUpdateProfile.View'
, [
    'Backbone'
  , 'nvt_anuualupdateform_update_profile.tpl'
  , 'Backbone.FormView'
  , 'GlobalViews.Message.View'
  ,	'underscore'
  ,	'jQuery'
  , 'Utils'


  ]
, function
  (
    Backbone
  , nvt_myorganisation_update_profile_tpl
  , BackboneFormView
  , MessageView
  ,	_
  ,	jQuery
  , Utils

  )
{
  'use strict';

    return Backbone.View.extend({
           

        template: nvt_myorganisation_update_profile_tpl

        , title: Utils.translate('Update Profile')

        ,initialize: function(options)
            {
                this.options = options;
                this.getjsonrequest = options.getjsonrequest;
                this.application = options.application;
                this.page_header = "Update Profile";	
                this.modalClass ='modal-md';  
                var self = this;
                BackboneFormView.add(this);
            }

        ,    events: 
            {
              'submit form': 'saveTheForm'
            }   
           
        ,   validateEmail : function (email) {
                var self = this;
                var re = /\S+@\S+\.\S+/;
                return re.test(email);
            }

        ,   validatePhoneNumber : function(phone) {
            var self = this;
            var cleaned = phone.replace(/[\s()-]/g, '');
            var regex = /^\+?[1-9]\d{6,14}$/;
            return regex.test(cleaned);
        }

        ,   validateUrl : function (url) {
            if (!url) return false;
            try {
                var testUrl = /^https?:\/\//i.test(url) ? url : 'http://' + url;
                var hostname = new URL(testUrl).hostname;
                // require a dotted domain (e.g. "example.com"), reject bare hosts like "http://abc"
                return /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i.test(hostname);
            } catch (e) {
                return false;
            }
        }

          ,saveTheForm: function(e)
            {
                e.preventDefault();
                e.stopImmediatePropagation();
                var self = this,
                	$target = jQuery(e.target),
			    	getfielddata = $target.serializeObject();

                    // Normalize the URL (add a scheme if missing) up front so both
                    // validation and the eventual submit see the same value.
                    var normalizedUrl;
                    if (getfielddata.types === "url" && getfielddata.getfieldvalueid) {
                        normalizedUrl = String(getfielddata.getfieldvalueid).trim();
                        if (normalizedUrl && !/^https?:\/\//i.test(normalizedUrl)) {
                            normalizedUrl = 'http://' + normalizedUrl;
                        }
                        getfielddata.getfieldvalueid = normalizedUrl;
                    }

                    if(!getfielddata.types || !getfielddata.getfieldvalueid.trim() || !getfielddata.internalid)
                    {
                        self.showMessage('Please enter value', 'error');  
                    }
                    else if(getfielddata.types == "email" && !self.validateEmail(getfielddata.getfieldvalueid))
                    {
                        self.showMessage('Email id required', 'error');  
                    }
                    else if(getfielddata.types == "phone" && !self.validatePhoneNumber(getfielddata.getfieldvalueid) || (getfielddata.types == "phone" && getfielddata.getfieldvalueid.length < 8))
                    {
                        self.showMessage('Business Contact number is Invalid', 'error');
                    }
                    else if(getfielddata.types == "url" && !self.validateUrl(getfielddata.getfieldvalueid))
                    {
                        self.showMessage('Please enter a valid website URL', 'error');
                    }
                    else{
                        // BackboneFormView.saveForm re-serializes the form straight from the
                        // DOM, so the normalized value must be written into the input itself.
                        if (getfielddata.types === "url") {
                            $target.find('[name="getfieldvalueid"]').val(normalizedUrl);
                        }

                        var promise = BackboneFormView.saveForm.apply(this, arguments);
                        this.$containerModal.addClass('fade').modal('show').data('bs.modal', null);
                        return promise && promise.then
                        (
                            function(responce)
                            {
                                if (responce.successMessage)
                                {
                                    self.showMessage(responce.successMessage, 'success');
                                }
                                else {
                                    self.showMessage(responce.errorMessage, 'error')
                                }
                                return false;   
                            }
                        );


                        // var global_view_message = new MessageView({
                        //     message: _('Data has been updated successfully ').translate()
                        // ,	type: 'success'
                        // });
        
                        // this.$('form').empty().html(global_view_message.render().$el.html());
                    }
               
               
            }

        , showMessage: function(message, type, field)
            {
                jQuery('.global-views-message-error').remove(); 
                jQuery('.global-views-message-success').remove(); 

                var messageView = new MessageView
                ({
                        message: message
                    ,   type: type
                    ,   closable: type =='error' ? true : false
                });
                if (typeof field !== 'undefined')
                {
                    this.application.getLayout().$('[data-input="' + field + '"]').append(messageView.render().$el);
                }
                else if (type =='error'){
                    this.application.getLayout().$('form').append(messageView.render().$el);
                }
                else
                {
                    this.application.getLayout().$('form').empty().html(messageView.render().$el);
                    setTimeout(function() {
                        jQuery("[data-dismiss=modal]").trigger({ type: "click" });
                    }, 1000);
                }
            }    

            
        ,getContext: function() {
            
            var self = this;
            return {
        
               title : this.title,

               getlblName : this.options.getjsonrequest.getlblName || '',

               getfieldvalueid : this.options.getjsonrequest.getfieldvalueid || '',

               getfieldvalue: this.options.getjsonrequest.getfieldvalue || '',

               getinternalid : this.options.getjsonrequest.getinternalid || '',

               gettextarea :  this.options.getjsonrequest.gettextarea || false,

               getdwn :  this.options.getjsonrequest.getdwn || false,

               gettext :  this.options.getjsonrequest.gettext || false,
               
           }
         }        

    });
});
